import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/galle.webp',
  './images/G2.webp',
  './images/G1.webp',
  './images/Photo/S5.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Galle, located on the southern coast of Sri Lanka, offers a captivating mix of colonial charm, coastal beauty, and history.

  Key highlights include:

  • Galle Fort – A UNESCO World Heritage Site built by the Portuguese and later fortified by the Dutch. Explore cobblestone streets, cafes, art galleries, and churches with ocean views.
  • Sea Turtle Hatcheries – Nearby Hikkaduwa is known for conservation centers where you can see baby turtles and learn about marine life.
  • Unawatuna Beach – Famous for soft sands and turquoise waters, ideal for swimming and relaxing.
  • Snorkeling & Marine Life – Great spots in Hikkaduwa for snorkeling among coral reefs and colorful fish.
  • Local Markets – Visit vibrant markets for fresh produce, spices, crafts, and local snacks.
  • Colonial Architecture – Discover Dutch-era buildings, historic churches, and mosques within the Fort.
  • Scenic Beauty – Coastal landscapes, ocean views, and historic streets perfect for photography.
  Galle is an ideal destination for relaxation, adventure, and cultural discovery.`,

    zh: `加勒位于斯里兰卡南部海岸，是殖民风情、海岸美景与丰富历史的完美融合。

  主要亮点包括：

  • 加勒堡 – 联合国教科文组织世界遗产，由葡萄牙人建造，后由荷兰人加固。鹅卵石街道、咖啡馆、艺术画廊、古老教堂与海景共同营造迷人氛围。
  • 海龟孵化场 – 附近的希卡杜瓦以海龟保护中心而闻名，可近距离观察小海龟，了解海洋生态。
  • 乌纳瓦图纳海滩 – 柔软沙滩与湛蓝海水，是游泳和放松的理想之地。
  • 浮潜与海洋生物 – 希卡杜瓦是浮潜胜地，可探索珊瑚礁与丰富的海洋生物。
  • 本地市场 – 热闹的市场提供新鲜农产品、香料、手工艺品和地道小吃。
  • 殖民建筑 – 加勒堡内可见荷兰时期建筑、教堂与清真寺，感受历史文化。
  • 风景如画 – 海岸线、老街区和历史建筑，是摄影爱好者的天堂。

  加勒是一个融合放松、探险与文化体验的理想海滨胜地。`
  };


  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/galle.webp" className="travel-image2" />
          <img src="./images/G2.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Galle, Sri Lanka</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Galle</h2>
          <p className="carousel-subheading">A blend of colonial history, coastal charm, and marine life</p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc}  className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
